import { createAction, handleActions } from 'redux-actions';
import { applyPenders } from 'redux-pender';
import produce from 'immer';


/* ACTION TYPE */
const SET_PHONE_INPUT = 'auth/SET_ID_INPUT';

/* ACTION CREATOR */
const setPhoneInput = createAction(SET_PHONE_INPUT, (value) => value);

/* EXPORT ACTION CREATORS */
export const actionCreators = {
    setPhoneInput,
}

const initialState = {
  id: '',
};

const reducer = handleActions({
  [SET_PHONE_INPUT]: (state, action) => {
    return produce(state, (draft) => {
        if (!action) return;
        draft.id = action.payload;
    });
  },
}, initialState);

export default applyPenders(reducer, [])